var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57574 4.73226L6 5.15653L6.42426 4.73226L10.308 0.848528L11.1515 1.692L7.26774 5.57574L6.84347 6L7.26774 6.42426L11.1515 10.308L10.308 11.1515L6.42426 7.26774L6 6.84347L5.57574 7.26774L1.692 11.1515L0.848528 10.308L4.73226 6.42426L5.15653 6L4.73226 5.57574L0.848528 1.692L1.692 0.848528L5.57574 4.73226Z",
    fill: "#49454F",
    stroke: "#AD2F2F",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ex-red.faa6105b7f0147885bfd0a03cacddd16.svg";